<template>
  <component
    :is="href ? 'a' : 'span'"
    :href="href"
    class="def-link-brown"
    :class="{ 'def-link-brown_disabled': disabled }"
    :target="target"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DefLinkBrown',
  props: {
    href: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '_self',
    },
  },
};
</script>

<style lang="scss" scoped>
.def-link-brown {
  display: inline-block;
  cursor: pointer;
  color: var(--color-golden-browm);
  transition: 0.2s linear color;
  &_disabled {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
}
a.def-link-brown {
  //text-decoration-color: currentColor;
  &:hover {
    text-decoration-line: underline;
    text-underline-position: under;
  }
}
</style>
